<div class="completed-maintenances" *transloco="let t; prefix: 'maintenanceOverview'">
  <div class="filter-container pb-3">
    <app-search
      [placeholder]="t('table.searchAsset')"
      [disabled]="isLoading"
      (searchTermUpdated)="onSearchTermUpdate($event)"
      [searchTerm]="searchTerm"
      [customWidth]="'300px'">
    </app-search>
  </div>

  <div class="table-container">
    <div class="table-inner">
      @if (isLoading) {
        <div class="loading-overlay">
          <span class="spinner-border"></span>
        </div>
      } @else if (hasError) {
        <div class="state-overlay">
          <app-error-state></app-error-state>
        </div>
      } @else if (!completedMaintenances.length) {
        <div class="state-overlay">
          <app-empty-state></app-empty-state>
        </div>
      }

      <table
        class="maintenance-table"
        [class.is-loading]="isLoading"
        [class.is-full-page]="!isLoading && completedMaintenances.length >= pageSize">
        <thead>
          <tr>
            <th class="asset">{{ t('table.asset') }}</th>
            <th class="date">{{ t('table.date') }}</th>
            <th class="source">{{ t('table.source') }}</th>
            <th class="downtime">{{ t('table.downtime') }}</th>
            <th class="event">{{ t('table.event') }}</th>
            <th class="cost">{{ t('table.cost') }}</th>
            <th class="status">{{ t('table.status') }}</th>
          </tr>
        </thead>
        <tbody>
          @if (isLoading) {
            <tr class="loading-row">
              <td colspan="7"></td>
            </tr>
          } @else if (completedMaintenances.length) {
            @for (row of completedMaintenances; track row.id) {
              <tr>
                <td class="asset">
                  <span class="asset-name" [title]="row.assetName">{{ row.assetName }}</span>
                </td>
                <td class="date">
                  <span>{{ formatDate(row.completedAt) }}</span>
                </td>
                <td class="source">
                  <div class="two-line-cell">
                    <span class="source-text">{{ getMaintenanceSource(row.maintenanceSource) }}</span>
                    <span class="sub-text">{{ formatDate(row.createdAt) }}</span>
                  </div>
                </td>
                <td class="downtime">{{ row.downtime + t('table.hours') }}</td>
                <td class="event" [title]="getMaintenanceEvent(row)">{{ getMaintenanceEvent(row) }}</td>
                <td class="cost">{{ formatCurrency(row.cost) }}</td>
                <td class="status">
                  <span class="status-badge status-badge--complete">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM6.66603 10.9407L4.1907 8.4707L5.13203 7.5267L6.6647 9.0567L10.194 5.52736L11.1367 6.47003L6.66603 10.9407Z"
                        fill="#3873C9" />
                    </svg>
                    {{ t('table.complete') }}
                  </span>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="table-footer">
      <p class="pagination-text">{{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}</p>

      <app-pagination [totalPages]="totalPages" [currentPage]="currentPage" (pageChange)="onPageChange($event)"></app-pagination>

      <button class="export-btn" [class.invisible]="true" (click)="onExportClick()" [disabled]="isLoading">
        <span>{{ t('table.export') }}</span>
        <img src="./assets/images-fuel/downloadIcon.svg" [attr.alt]="'common.export' | transloco" />
      </button>
    </div>
  </div>
</div>